import { ref } from 'vue';
import { getJobProfileSettings } from '@/api/jobProfileSettings';

export const useJobProfileComparisonFieldSettings = () => {
  const fieldKeysOrder = ref([]);
  const hiddenFieldKeys = ref([]);
  const fieldSettingsLoaded = ref(false);

  const loadFieldSettings = async () => {
    try {
      const data = await getJobProfileSettings();
      const fields = data.fields || [];

      hiddenFieldKeys.value = fields
        .filter((row) => row?.is_hidden)
        .map((row) => row.key)
        .filter(Boolean);

      fieldKeysOrder.value = fields
        .filter((row) => row && !row.is_hidden)
        .map((row) => row.key)
        .filter(Boolean);
    } catch {
      fieldKeysOrder.value = [];
      hiddenFieldKeys.value = [];
    } finally {
      fieldSettingsLoaded.value = true;
    }
  };

  loadFieldSettings();

  return {
    fieldKeysOrder,
    hiddenFieldKeys,
    fieldSettingsLoaded,
  };
};
